<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Güncel Borç Yok"
      type="success"
      :closable="false"
      v-if="!Borclar && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Borclar"
      v-if="Borclar"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      @current-change="BorcSec">
      <el-table-column
        label="Cari"
        prop="Unvan">
      </el-table-column>
      <el-table-column
        width="120"
        align="right"
        label="Borç"
        prop="Bakiye">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      Height: window.innerHeight - 270,
      Borclar: null,
      AltToplam: 0,
      lo: false
    }
  },
  methods: {
    BorcSec(val) {
      this.$router.push('/vezne/odeme/' + val.Cari_id + '/' + val.Bina_id);
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/borc'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Borclar = response.Liste
            this.AltToplam = response.AltToplam
            this.$emit('Borc', response.AltToplam);
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam;

      return sums;
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Borclar.vue